import { render, staticRenderFns } from "./business-income.vue?vue&type=template&id=0396e228&scoped=true&"
import script from "./business-income.vue?vue&type=script&lang=js&"
export * from "./business-income.vue?vue&type=script&lang=js&"
import style0 from "./business-income.vue?vue&type=style&index=0&id=0396e228&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0396e228",
  null
  
)

export default component.exports